import "./style.css";
import { startGame } from "./game";

startGame();
